<div class="insights-suggestions-panel" *ngIf="panelOpened">
  <div class="panel-header">
    <div class="header-title">
      <mat-icon class="header-icon">lightbulb</mat-icon>
      <h3>{{ getTitle() }}</h3>
    </div>
    <div class="header-badge" *ngIf="getPendingCount() > 0">{{ getPendingCount() }} {{ getPendingBadgeText() }}</div>
  </div>

  <div
    class="sorting-controls"
    style="
      padding: 4px 24px 8px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 8px;
      margin-bottom: -8px;
    "
    *ngIf="!isLoading && suggestions.length > 0"
  >
    <span style="font-size: 12px; margin-right: 8px; color: #888; letter-spacing: 0.3px">{{ getSortByText() }}</span>
    <button
      mat-stroked-button
      [matMenuTriggerFor]="sortMenu"
      style="
        font-size: 12px;
        min-width: unset;
        padding: 0 8px 0 8px;
        height: 28px;
        line-height: 26px;
        border-radius: 14px;
        border-color: rgba(0, 0, 0, 0.12);
      "
    >
      <span style="display: flex; align-items: center">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 6px; color: #666">sort</mat-icon>
        <span style="font-weight: 500; color: #333; line-height: 1">
          {{ currentSort === 'impact' ? getSortImpactText() : getSortDateText() }}
        </span>
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-left: 4px; color: #888">
          keyboard_arrow_down
        </mat-icon>
      </span>
    </button>
    <mat-menu #sortMenu="matMenu">
      <button mat-menu-item (click)="setSort('impact')">
        <mat-icon *ngIf="currentSort === 'impact'">check</mat-icon>
        <span>{{ getSortImpactText() }}</span>
      </button>
      <button mat-menu-item (click)="setSort('date')">
        <mat-icon *ngIf="currentSort === 'date'">check</mat-icon>
        <span>{{ getSortDateText() }}</span>
      </button>
    </mat-menu>
  </div>

  <div
    class="panel-content"
    *ngIf="isLoading"
    style="display: flex; justify-content: center; align-items: center; padding: 40px"
  >
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="panel-content" *ngIf="!isLoading && suggestions.length > 0">
    <div
      *ngFor="let suggestion of suggestions"
      class="suggestion-card"
      [ngClass]="{
        'status-pending': suggestion.status === 'pending',
        'status-accepted': suggestion.status === 'accepted',
        'status-rejected': suggestion.status === 'rejected'
      }"
    >
      <div class="suggestion-date">{{ formatDate(suggestion.date) }}</div>
      <div class="suggestion-header">
        <span class="suggestion-type-badge" [attr.data-type]="suggestion.type">
          {{ getTypeLabel(suggestion.type) }}
        </span>
        <span class="suggestion-priority-badge" [attr.data-priority]="suggestion.priority">
          {{ getPriorityLabel(suggestion.priority) }}
        </span>
      </div>
      <div class="suggestion-title">{{ suggestion.title }}</div>
      <div class="suggestion-description" *ngIf="false">{{ suggestion.description }}</div>
      <div class="suggestion-impact">
        <mat-icon class="impact-icon">attach_money</mat-icon>
        <span>
          {{ getEstimatedImpactLabel() }}
          <b>{{ formatCurrency(suggestion.estimatedImpact) }}</b>
        </span>
      </div>

      <button mat-button class="view-details-button" (click)="viewDetails(suggestion)">
        <mat-icon>visibility</mat-icon>
        {{ getViewDetailsText() }}
      </button>

      <div class="suggestion-actions" *ngIf="suggestion.status === 'pending'">
        <button
          mat-raised-button
          color="primary"
          class="action-button accept-button"
          (click)="acceptSuggestion(suggestion)"
        >
          <mat-icon>check_circle</mat-icon>
          {{ getAcceptButtonText() }}
        </button>
        <button mat-stroked-button class="action-button reject-button" (click)="rejectSuggestion(suggestion)">
          <mat-icon>cancel</mat-icon>
          {{ getRejectButtonText() }}
        </button>
      </div>

      <div class="suggestion-status" *ngIf="suggestion.status !== 'pending'">
        <mat-icon *ngIf="suggestion.status === 'accepted'" class="status-icon accepted">check_circle</mat-icon>
        <mat-icon *ngIf="suggestion.status === 'rejected'" class="status-icon rejected">cancel</mat-icon>
        <span>{{ getStatusText(suggestion.status) }}</span>
      </div>
    </div>
  </div>

  <div class="panel-empty" *ngIf="!isLoading && suggestions.length === 0">
    <mat-icon class="empty-icon">lightbulb_outline</mat-icon>
    <p>{{ getEmptyMessage() }}</p>
  </div>
</div>
